namespace Matrix.Dashboards {
    export interface DatasetListColumnsResponse extends Serenity.ServiceResponse {
        Columns?: Data.DataColumn[];
    }
}
